import { useEffect } from 'react';

export const useFocusFormField = (setFocus, fieldName, depsArr = []) => {
  useEffect(() => {
    setTimeout(() => {
      setFocus(fieldName);
    }, 50);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fieldName, setFocus, ...depsArr]);
};
